'use strict';

import request from 'superagent';
import api from './core';

/**
 * Creates a Gibi process on the server. It will run asynchronously as a task
 * so we need to poll the status of the task using retrieve() below.
 *
 * @param data {object} Data in the same format as what will be sent to the API
 */
export function create({data}) {
    return api.promisify(api.prepare(
        request.post(api.url(
            `/gibi/`
        ))
    ).send(data));
}

/**
 * Retrieves the status of a Gibi process to know how far it is, is it done,
 * and so forth.
 *
 * @param progress {string} ID of the progress handle
 */
export function retrieve({progress}) {
    return api.forwardResult(api.prepare(
        request.get(api.url(
            `/gibi/${encodeURIComponent(progress)}/`
        ))
    ), 'status');
}



// WEBPACK FOOTER //
// ./src/api/gibi.js